var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PurchaseNoDeliveryComponent',{attrs:{"goods-type":"S0402","title":"사급 원자재 입고","input-type":_vm.inputType,"purchase-type":_vm.purchaseType}})}
var staticRenderFns = []

export { render, staticRenderFns }